const getParam = (option) => {
	// 1. 处理attach参数
	if (option.attach) {
		return JSON.stringify({
			'attach': option.attach
		});
	}
	
	// 2. 处理小红书相关参数
	if (option.click_id) {
		return JSON.stringify({
			'clickid': option.click_id
		});
	}
	
	// 3. 处理各种clickid变体（优先级：sign > requestId > 其他clickid）
	if (option.sign) {
		// 丰巢 - 最高优先级
		let a = {
			'sign': option.sign || '',
			'requestId': option.requestId || '',
			'province': option.province || '',
			'city': option.city || '',
		};

		
		return JSON.stringify(a);
	}
	
	if (option.requestId) {
		let a = {
			'requestId': option.requestId || '',
			'adId': option.adId || '',
			'pn': option.pn || ''
		};
		return JSON.stringify(a);
	}
	
	// 4. 处理其他clickid参数
	// if (option.clickid) {

	// 	return option.clickid;
	// }
	
	if (option.qz_gdt) {
		return JSON.stringify({
			'clickid': option.qz_gdt
		});
	}
	
	if (option.gdt_vid) {
		return JSON.stringify({
			'clickid': option.gdt_vid
		});
	}
	
	// 5. 处理tid参数
	if (option.tid) {
		let a = {
			'tid': option.tid || '',
			'lbid': option.lbid || '',
			"pageId": option.pageId || ''
		};
		return JSON.stringify(a);
	}
	
	// 6. 处理imei参数
	if (option.imei) {
		let a = {
			'imei': option.imei || '',
			'adId': option.adId || '',
		};
		return JSON.stringify(a);
	}
	
	// 7. 处理其他字符串参数（按优先级排序）
	if (option.param) {
		return option.param;
	}
	
	if (option.qcjParamStr) {
		return option.qcjParamStr;
	}
	
	if (option.jtcAdRequestId) {
		return option.jtcAdRequestId;
	}
	
	if (option.pushid || option.push_id) {
		return option.pushid || option.push_id;
	}
	
	if (option.state_json) {
		let str = option.state_json;
		let reg = RegExp(/&quot;/);
		if (reg.test(str)) {
			return encodeURIComponent(str.replace(/&quot;/g, '"'));
		} else {
			return encodeURIComponent(str);
		}
	}
	
	if (option.tokenid || option.tokenId) {
		return option.tokenid || option.tokenId;
	}
	
	if (option.llgclickid) {
		return option.llgclickid;
	}
	
	if (option.bxm_id) {
		return option.bxm_id;
	}
	
	if (option.a_oId || option.a_oid) {
		return option.a_oId || option.a_oid;
	}
	
	if (option.cpparamOrderId) {
		return option.cpparamOrderId;
	}
	
	// 8. 处理需要返回URL的情况
	if (option.bd_vid || option.projectid || option.request || option.creativeid || option.union_site|| option.clickid) {
		return window.location.href;
	}
	
	if (option.callback) {
		// 宝宝树
		return encodeURIComponent(option.callback);
	}
	
	// 9. 处理URL中的state_json参数
	var str = decodeURIComponent(window.location.search);
	if (str.indexOf('state_json=') != -1) {
		str = str.match(/state_json=(\S*)/)[1];
		return str;
	}
	
	// 10. 默认返回空字符串
	return '';
}

export default {
	getParam
}